module.exports = __webpack_public_path__ + "assets/img/22.42b03c19.png";